module.exports = __webpack_public_path__ + "assets/img/thumb-AIF-Social-Static-Ad.b45550a6.webp";